import { render, staticRenderFns } from "./FakePaymentPage.vue?vue&type=template&id=fddd29b4&"
import script from "./FakePaymentPage.vue?vue&type=script&lang=js&"
export * from "./FakePaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./FakePaymentPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports